import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ClinicService {

  private apiUrl: string;
  
  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
      const token = localStorage.getItem('jwtToken');
      return {
        headers: new HttpHeaders({
          'Authorization' : `Bearer ${token}`
        })
      }
    }

  getClinic() {
    return this.http.get(
      // this.common.getBaseUrl() + 'clinic'
      this.apiUrl + '/clinic',
      this.getAuthHeaders()
    );
  }

  addClinic(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addPatient";
    return this.http.post(this.apiUrl + '/clinic', payload, this.getAuthHeaders());
  }

  updateClinic(payload: any) {
    payload["action"] = "updatePatient";
    return this.http.put(this.apiUrl + '/clinic/' + payload.id, payload, this.getAuthHeaders());
  }

  deleteClinic(payload: any) {
    payload["action"] = "deletePatient";
    return this.http.put(this.apiUrl + '/clinic', payload, this.getAuthHeaders());
  }
}
